import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../assets/logo.png';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#0A0A0A] text-gray-300 border-t border-[#E31E24]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={logo} alt="T-RaX" className="h-12 w-auto" />
              <div>
                <h3 className="text-white font-black text-xl">T-RAX</h3>
                <p className="text-[#E31E24] text-xs tracking-wider">Car Care</p>
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-4">{t('footer.aboutText')}</p>
            <p className="text-xs text-gray-500 italic">"{t('home.hero')}"</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">{t('footer.quickLinks')}</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-sm hover:text-[#E31E24] transition-colors">{t('nav.home')}</Link>
              <Link to="/magaza" className="text-sm hover:text-[#E31E24] transition-colors">{t('nav.shop')}</Link>
              <Link to="/favorilerim" className="text-sm hover:text-[#E31E24] transition-colors">{t('nav.favorites')}</Link>
              <Link to="/kargo-takip" className="text-sm hover:text-[#E31E24] transition-colors">{t('nav.tracking')}</Link>
              <Link to="/iletisim" className="text-sm hover:text-[#E31E24] transition-colors">{t('nav.contact')}</Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">{t('footer.contactInfo')}</h4>
            <div className="flex flex-col gap-3 text-sm">
              <div className="flex items-start gap-2">
                <span className="text-[#E31E24] shrink-0">📍</span>
                <span className="text-gray-400 text-xs leading-relaxed">
                  Yeni Birlik Sanayi Sitesi, Saray, 675. Cadde No:24/12, 06980 Kahramankazan/Ankara
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-[#E31E24] shrink-0">📞</span>
                <a href="tel:+903128151165" className="hover:text-[#E31E24] transition-colors">0312 815 11 65</a>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-[#E31E24] shrink-0">✉️</span>
                <a href="mailto:info@sbtkimya.com.tr" className="hover:text-[#E31E24] transition-colors text-xs">info@sbtkimya.com.tr</a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 pt-6 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} T-RaX Car Care. {t('footer.rights')}
          </p>
          <div className="flex items-center gap-4">
            <Link to="/gizlilik-politikasi" className="text-xs text-gray-500 hover:text-[#E31E24] transition-colors">
              Gizlilik Politikası
            </Link>
            <Link to="/kullanim-kosullari" className="text-xs text-gray-500 hover:text-[#E31E24] transition-colors">
              Kullanım Koşulları
            </Link>
            <a href="https://www.instagram.com/traxcarcareproducts/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#E31E24] transition-colors" title="Instagram">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <p className="text-xs text-gray-600">
              🚗 {t('home.hero')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
